import {Pagination} from '@store/common/pagination.model';
import {TableFilter, TableFilterType} from '@store/common/tableFilter.model';
import {GlobalStatus} from '@store/common/globalStatus.enum';
import { ManageContact } from '@store/common/organisation.model';

export interface SuppliersUnitsFilters {
  search: string;
  tableFilters: TableFilter[];
}

export namespace SuppliersUnitsFilters {
  export const initTableFilters = (supplierId?: string) => TableFilterType.initTableFilters([
    TableFilterType.SUPPLIER_ORGANISATION,
    TableFilterType.ORGANISATION_TYPOLOGY,
    TableFilterType.ORGANISATION_DOMAIN,
  ]).map((f) => ({
    ...f,
    hide: (!!supplierId && f.type === TableFilterType.SUPPLIER_ORGANISATION),
    values: (f.type === TableFilterType.SUPPLIER_ORGANISATION && !!supplierId) ? [{label: '', value: supplierId}] : [],
  }));
}

export interface SuppliersUnitsPagination extends Pagination {
  data: SuppliersUnit[];
}

export interface SuppliersUnitUI {
  id: number;
  selected: boolean;
}

export interface SuppliersUnit {
  id: number;
  status: GlobalStatus;
  name: string;
  organisationName: string;
  city: string;
  phone: string;
  email: string;
  country: string;
  street: string;
  zip: string;
  supplierOrganisationUnitContacts: ManageContact[];
  unitManagers: any[];
}